export enum PriceLabelEnum {
  APPROPRIATION = 'Appropriation',
  GREEN_ORDINATION = 'GreenOrdination',
  AGREEMENT = 'Agreement',
  AGREEMENT_GROUP = 'AgreementGroup',
  PRICE_LIST = 'PriceList',
  CAMPAIGN = 'Campaign',
  CAMPAIGN_PART = 'CampaignPart',
  CAMPAIGN_SALES_PROMOTION_NODE = 'CampaignSalesPromotionNode',
  CAMPAIGN_SALES_PROMOTION_PART = 'CampaignSalesPromotionPart',
  POSITIVE_LIST = 'PositiveList',
}
